import config from 'modules-core/config'
import log from 'modules-core/log'

const logger = log.getLogger('urlSystem')

export const createUrlSystem = () => {
	const maybePort = (port: string) =>
		port && port !== '80' && port !== '443' ? `:${port}` : ''
	const maybeSubdomain = (subdomain: string) => subdomain ? `${subdomain}.` : ''
	const siteOrigin = () =>
		`${config.httpProtocol}://${config.httpHostname}${maybePort(config.httpPort)}`
	return {
		// Replace local hostnames. We might have inconsistent URLs in redis if the site
		// has been accessed at multiple locations.
		replaceLocalDomainAndPort: (path: string) => {
			let new_path = path.replace(
				RegExp('://[^/]*(localhost|lvh.me)[^/]+'),
				`://${config.httpHostname}${maybePort(config.httpPort)}`,
			)
			if (new_path.startsWith('/') && !new_path.startsWith('//')) {
				new_path = `${siteOrigin()}${new_path}`
			}
			if (new_path !== path)
				logger.debug(`replaceLocalDomainAndPort(): ${path} => ${new_path}`)
			return new_path
		},

		createUrlHttp: (path: string, subdomain: string = '') => {
			return `${config.httpProtocol}://${maybeSubdomain(subdomain)}${config.httpHostname}${maybePort(config.httpPort)}/${path}`
		},
	}
}

export type iUrlSystem = ReturnType<typeof createUrlSystem>

export const urlSystem = createUrlSystem()
export default urlSystem
